//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * 普通买家form
 * @author Spark
 */
import FormMixins from '~/mixins/form-mixins';
import SubFormMixins from "./form-mixins";
export default {
  name: 'module-putong',
  mixins: [FormMixins, SubFormMixins],
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      model: {
        // 本人姓名
        name: null,
        // 公司全称
        title: null,
        // 营业执照
        businessLicense: null,
        // 发票图片
        invoiceImg: null
      }
    };
  },
  methods: {
    handleUploadBusinessLicense: function handleUploadBusinessLicense(img) {
      this.model.businessLicense = img;
    },
    handleUploadInvoiceImg: function handleUploadInvoiceImg(img) {
      this.model.invoiceImg = img;
    }
  }
};